import { useSelector } from 'react-redux'

import { skipToken } from '@reduxjs/toolkit/query'

import { useGetVideoSessionsQuery } from './videoSessionApi'
import { getAuthUserId } from '../../data/auth/authSelectors'

export const useVideoSessionForAppointment = (appointmentId?: number) => {
  const providerId = useSelector(getAuthUserId)
  const { data: videoSessions } = useGetVideoSessionsQuery(appointmentId ? { appointmentId, providerId } : skipToken)
  if (!appointmentId) {
    return null
  }

  return videoSessions?.length ? videoSessions[0] : null
}
